import type { ReactNode } from 'react';

export const symbol_stacked_inbox: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M210-240q-24 0-42-18t-18-42v-480q0-24 18-42t42-18h660q24 0 42 18t18 42v480q0 24-18 42t-42 18H210Zm0-214v154h660v-154H680q-19 45-55.5 71.5T540-356q-48 0-84.5-26.5T400-454H210Zm330 38q29 0 58-22t34-51q2-11 10-18t19-7h209v-266H210v266h209q11 0 19 7t10 18q5 29 34 51t58 22ZM90-120q-24 0-42-18t-18-42v-439q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62Q90-631.75 90-619v439h619q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H90Zm120-180h660-660Z"
		/>
	</svg>
);
